import axios from 'axios'
import CONFIG from '../config'
import storeNumbers from './storeNumbers'

const {
  BASE_URL,
  API_KEY,
  STORE_FINDER_API_KEY,
  STORE_FINDER_BASE_URL,
  LOCKER_TOKEN,
} = CONFIG

axios.defaults.baseURL = BASE_URL

export const fetchOrdersToCollect = orderId => {
  const config = {
    url: `/customerorder/v2/sources/osp/orders/${orderId}`,
    params: {
      apikey: API_KEY,
    },
  }
  return makeAPICall(config)
}

export const fetchLockerOrdersToCollect = orderId => {
  const config = {
    url: `https://api.flexilocker.com/get/order/${orderId}/codes`,
    headers: {
      get: {
        token: LOCKER_TOKEN,
      },
    },
  }
  return makeLockerAPICall(config)
}

export const confirmCustomerArrival = params => {
  const { orderId, retailerSiteId, collectLocation } = params
  const config = {
    url: `/customerorder/v2/sources/osp/orders/${orderId}/@customerwaiting`,
    method: 'post',
    params: {
      apikey: API_KEY,
    },
    data: {
      retailerSiteId,
      collectLocation,
    },
  }
  return makeAPICall(config)
}

export const fetchStoreDetails = async retailerStoreId => {
  const storeId = retailerStoreId === '84324154' ? '152' : retailerStoreId
  const config = {
    url: `${STORE_FINDER_BASE_URL}location/v2/stores/${storeId}`,
    params: {
      apikey: STORE_FINDER_API_KEY,
    },
  }
  try {
    const response = await axios.request(config)
    if (!response.data.mobileNumber) {
      const store = storeNumbers.find(details => details.id === storeId)
      const mobileNumber = store ? store.mobile : '0345 611 6111'
      return { ...response.data, mobileNumber }
    } else {
      return response.data
    }
  } catch (error) {
    throw error.message
  }
}

const makeAPICall = async config => {
  try {
    const response = await axios.request(config)
    return response.data.body
  } catch (error) {
    throw error.message
  }
}

const makeLockerAPICall = async config => {
  try {
    const response = await axios.request(config)
    return response.data
  } catch (error) {
    throw error.message
  }
}
